import React, { FC, useState } from 'react';
import SidebarLink from './SidebarLink';

import { basicLinkStyles } from './styles';
import { Typography } from '@mui/material';
import { MoreHoriz as ThreeDotsIcon } from '@mui/icons-material';

import SidebarLinkSet from '@/components/shared/Sidebar/SidebarLinkSet';
import Box from '@mui/system/Box';
import { SidebarContentProps } from '@/components/shared/Sidebar/SidebarViews';
import { useSidebarNavigation } from '@/contexts/sidebarNavigationContext';
import { ApiProvider } from '@/provider/ApiProvider';
import DashboardComments from '@/components/shared/Comments/DashboardComments';

const SidebarTools: FC<SidebarContentProps> = ({ links, compactSidebarMenus = false }) => {
  const { visibilityCompare, propertyDetails, updateValue } = useSidebarNavigation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleToggleVisibilityCompare = () => {
    updateValue('visibilityCompare', !visibilityCompare);

    // @ts-expect-error We always have a content if this comp was called.
    if (!!Object.keys(propertyDetails).length) {
      setTimeout(() => {
        // @ts-expect-error ... and those couldn't be empty.
        const { full_name, profile_img, category_name, property_type } = propertyDetails;

        if (document.getElementById('search_hide0') != null) {
          // @ts-expect-error DOM operations.
          document.getElementById('search_hide0').style.display = 'none';
          // @ts-expect-error DOM operations.
          document.getElementById('selected_data0').style.display = 'block';
          // @ts-expect-error DOM operations.
          document.getElementById('full_name_set0').innerHTML = full_name;
          // @ts-expect-error DOM operations.
          document.getElementById('image_set0').src = profile_img;
          // @ts-expect-error DOM operations.
          document.getElementById('category_set0').innerHTML = category_name;
          // @ts-expect-error DOM operations.
          document.getElementById('property_type_set0').innerHTML = property_type;
        }
      }, 500);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  const allToolLinks = [...links.visible, ...links.hidden];

  return (
    <Box>
      <Typography
        sx={{
          color: '#DBDBDB',
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: 'normal',
          textTransform: 'uppercase',
        }}
      >
        Tools
      </Typography>

      {Boolean(ApiProvider.permission('tools_comments')) && (
        <div className='top_icons'>
          <DashboardComments
            comment_module_type='dashboard'
            comment_page=''
            page_brand_id=''
            page_property_id=''
            // @ts-expect-error: any === sting.
            page_contract_id=''
            page_activation_id=''
            isSidebarLink={true}
          />
        </div>
      )}

      {!compactSidebarMenus && links?.visible.length ? (
        <>
          {links.visible.map(({ to, icon, text, target, handleClick, isExternal }, index) => {
            return (
              <SidebarLink
                key={index}
                to={to}
                icon={icon}
                text={text}
                boxContainerStyles={basicLinkStyles}
                target={target}
                isExternal={isExternal}
                handleClick={() => {
                  if (typeof handleClick === 'function') {
                    // If handleClick is a function, call it directly
                    handleClick();
                  } else if (handleClick === 'compare') {
                    // If handleClick is the string 'compare', call handleToggleVisibilityCompare
                    handleToggleVisibilityCompare();
                  }
                }}
              />
            );
          })}
        </>
      ) : null}

      {(compactSidebarMenus ? allToolLinks.length : links?.hidden.length) ? (
        <SidebarLinkSet
          id={id}
          title={compactSidebarMenus ? 'Tools' : 'More tools'}
          icon={ThreeDotsIcon}
          links={compactSidebarMenus ? allToolLinks : links.hidden}
          open={open}
          anchorEl={anchorEl}
          onTriggerClick={handleClick}
        />
      ) : null}
    </Box>
  );
};

export default SidebarTools;
